import React from 'react'
import { Wrapper } from './styles'
import GenericButton from '../../../../components/GenericButton'
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined'
import { ButtonType } from '../../../../components/GenericButton/styles'
import { useAppDispatch } from '../../../../store'
import { removeSection, type ISurveySection } from '../../../../store/slices/SurveyTemplateSlice'
import { useTheme } from '@mui/material/styles'
import { notification } from '../../../../components/Notifications'
import { type Question } from '../../types'

interface SectionActionProps {
  totalSections: number
  section: ISurveySection
}

const SectionAction: React.FC<SectionActionProps> = ({ totalSections, section }) => {
  const dispatch = useAppDispatch()
  const theme = useTheme()

  const hasBranchingFilters = (section: ISurveySection): boolean | undefined => {
    return section?.surveyItems?.some((item: Question) => item?.branchingFilters && item.branchingFilters.length > 0)
  }

  const handleDeleteSection = (): void => {
    // Check Section have Branch Section
    if (hasBranchingFilters(section)) {
      notification('This Section contains a Branch section. You cannot delete this section', { variant: 'error' })
      return
    }
    dispatch(removeSection({ section }))
    notification('Section Successfully Deleted', { variant: 'success', subTitle: section.name })
  }

  const iconStyle = {
    width: theme.spacing(12),
    height: theme.spacing(12)
  }

  return (
    <Wrapper>
      <GenericButton
        onClick={handleDeleteSection}
        icon={<DeleteOutlineOutlinedIcon />}
        buttonType={ButtonType.Secondary}
        disabled={totalSections === 1}
        style={iconStyle}
      />
    </Wrapper>
  )
}

export default SectionAction
